'use client';

import React from 'react';
import { Footer as CloudUIFooter, Link, Stack, Typography } from '@unity/cloud-ui';
import { UnityColor } from '@unity/cloud-ui/icons/brands';
import { NestedKeyOf, useTranslations } from 'next-intl';
import onetrust from '@/lib/onetrust';

export const LINKS: { labelKey: NestedKeyOf<IntlMessages>; href: string }[] = [
  {
    labelKey: 'footer:links:legal',
    href: 'https://unity.com/legal',
  },
  {
    labelKey: 'footer:links:privacy-policy',
    href: 'https://unity.com/legal/privacy-policy',
  },
  {
    labelKey: 'footer:links:terms-of-use',
    href: 'https://unity.com/legal/terms-of-service',
  },
  {
    labelKey: 'footer:links:cookies',
    href: 'https://unity.com/legal/cookie-policy',
  },
  {
    labelKey: 'footer:links:personal-info',
    href: 'https://unity.com/legal/do-not-sell-my-personal-information',
  },
];

export const Footer = () => {
  const t = useTranslations();

  const handleCookieSettingClicked = (e) => {
    e.preventDefault();
    onetrust.openPreferenceCenter();
  };

  return (
    <CloudUIFooter
      links={
        <Stack
          gap={3}
          p={3}
          direction="column"
          sx={{
            bgcolor: (theme) => theme.vars.palette.background.paperElevation0,
            borderRadius: 2,
          }}
        >
          <Stack gap={3} direction="row" alignItems="center">
            <Stack gap={0.5} direction="row" alignItems="center">
              <UnityColor />
              <Typography variant="subtitle2" component="span">
                {t('footer:title')}
              </Typography>
            </Stack>
            <Typography variant="subtitle2" component="span">
              {t('footer:copyright-statement', {
                date: new Date().getFullYear().toString(),
              })}
            </Typography>
          </Stack>
          <Stack gap={1.5}>
            <Stack direction="row" gap={2.5} rowGap={0.5} flexWrap={{ xs: 'wrap', s: 'nowrap' }}>
              {Object.entries(LINKS).map(([key, { href, labelKey }]) => (
                <Typography key={key} variant="subtitle2" component="span">
                  <Link href={href} external flexShrink={0} underline="always" color="textPrimary">
                    {t(labelKey)}
                  </Link>
                </Typography>
              ))}
            </Stack>

            <Link href="#" onClick={handleCookieSettingClicked} underline="always" color="textPrimary">
              <Typography variant="subtitle2" component="span">
                {t('footer:privacy:cookie-settings')}
              </Typography>
            </Link>
          </Stack>

          <Typography variant="subtitle2" component="p" color="textSecondary">
            {t.rich('footer:unity-trademark-statement', {
              link: (chunks) => (
                <Link href="https://unity.com/legal/trademarks" external>
                  {chunks}
                </Link>
              ),
            })}
          </Typography>
        </Stack>
      }
    />
  );
};
